<template>
  <div>
    <!-- ヘッダー -->
    <v-app-bar color="primary" dark flat class="header">
      <v-btn style="position: absolute" icon @click="routerBack">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title style="min-width: fit-content;">{{ $t('communication.readySendBoxTitle') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <ClassFilterDialog
        v-model="selectedClassIds"
        :classes="nurseryClasses"
        @apply="onFilterApply"
      />
    </v-app-bar>

    <v-container class="padding-box">

      <!-- {{ $t('communication.readySendBoxList') }} -->
      <div>
        <v-list>
          <template v-if="!fetchLoading">
            <!-- 個別 -->
            <div class="font-weight-bold pa-1">{{ $t('communication.individualMessages') }}</div>
            <div v-if="chatReady.length === 0" class="pl-1">{{ $t('communication.noSavedMessages') }}</div>

            <div v-for="(chat, index) in chatReady" :key="chat.chatId">
              <template v-if="index > 0">
                <v-list-subheader
                  v-if="chat.date !== chatReady[index - 1].date"
                  class="attendance-list-header"
                >
                  <p v-if="chat.updatedAt" class="ml-3 text-black">{{ formatDate(chat.updatedAt) }}</p>
                </v-list-subheader>
              </template>
              <template v-if="index === 0">
                <v-list-subheader class="attendance-list-header">
                  <p v-if="chat.updatedAt" class="ml-3 text-black">{{ formatDate(chat.updatedAt) }}</p>
                </v-list-subheader>
              </template>

              <v-list-item @click="toChat(chat)">
                <div class="d-flex align-center pl-3">
                  <v-checkbox
                    v-model="checkbox"
                    v-if="checkReadyMine(chat.createdBy)"
                    :value="chat.chatId"
                    hide-details
                    @click.stop
                  ></v-checkbox>
                  <div class="d-block pt-2 pb-2">
                    <div class="d-flex">
                      <p>{{ chat.child.lastName }} {{ chat.child.firstName }}</p>
                      <v-chip color="primary" class="ml-2 pa-2" variant="outlined" size="x-small"
                        >{{ chat.createdBy?.lastName }} {{ chat.createdBy?.firstName }}</v-chip
                      >
                    </div>
                    <p 
                      class="text-grey mt-1" 
                      style="max-width: 10em; white-space: pre-wrap; word-break: break-all;"
                    >
                      {{ showLongText(chat.body) }}
                    </p>
                  </div>
                </div>

                <template v-slot:append>
                    <v-icon>mdi-chevron-right</v-icon>
                </template>

              </v-list-item>
            </div>

            <!-- 一斉送信 -->
            <div class="font-weight-bold mt-1 pa-1">{{ $t('communication.createBulkMessage') }}</div>
            <div v-if="bulkChatsReady.length === 0" class="pl-1">{{ $t('communication.noSavedMessages') }}</div>

            <div v-for="(bulkChat, index) in bulkChatsReady" :key="bulkChat.groupChatId">
              <template v-if="index > 0">
                <v-list-subheader
                  v-if="bulkChat.date !== bulkChatsReady[index - 1].date"
                  class="attendance-list-header"
                >
                  <p v-if="bulkChat.updatedAt" class="ml-3 text-black">{{ formatDate(bulkChat.updatedAt) }}</p>
                </v-list-subheader>
              </template>
              <template v-if="index === 0">
                <v-list-subheader class="attendance-list-header">
                  <p v-if="bulkChat.updatedAt" class="ml-3 text-black">{{ formatDate(bulkChat.updatedAt) }}</p>
                </v-list-subheader>
              </template>

              <v-list-item @click="toChatBulk(bulkChat)">
                <template v-slot:prepend>
                  <div class="mr-3">
                    <v-checkbox
                      v-model="checkboxBulk"
                      v-if="checkReadyMine(bulkChat.createdBy)"
                      :value="bulkChat.groupChatId"
                      hide-details
                      @click.stop
                    ></v-checkbox>
                  </div>
                </template>

                <div>
                  <div class="d-block pt-1 pb-2">
                    <div class="d-flex flex-column">
                      <div v-for="clas in bulkChat.to.classes" :key="clas.classId">
                        <p class="pr-1">{{ clas.className }}</p>
                      </div>
                    </div>
                    <div v-for="child in bulkChat.to.children" :key="child.childId">
                      <p class="pr-1">{{ child.lastName }} {{ child.firstName }}</p>
                    </div>
                    <v-chip 
                      color="primary"  
                      variant="outlined" 
                      size="x-small"
                      class="mb-2"
                    >
                      {{ bulkChat.createdBy?.lastName }} {{ bulkChat.createdBy?.firstName }}
                    </v-chip>
                    <p 
                      class="text-grey mt-1" 
                      style="max-width: 10em; white-space: pre-wrap; word-break: break-all;"
                    >
                      {{ showLongText(bulkChat.body) }}
                    </p>
                  </div>
                </div>

                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
                <v-divider class="my-2"></v-divider>
              </v-list-item>        
            </div>
          </template>
          <template v-else>
            <VueLoading :height="'50vh'" />
          </template>
        </v-list>
      </div>
    </v-container>
    <!-- footer -->
    <v-footer color="white" class="ready-footer">
      <v-row class="mt-2 mb-2">
        <v-col cols="6" class="pr-2 pl-2">
          <v-btn
            class=""
            color="error"
            variant="outlined"
            width="100%"
            @click="deleteChatReady"
            :loading="btnRemoveLoading"
            :disabled="disabled"
          >
            <div>
              <div class="text-h6 font-weight-bold message-btn">{{ $t('common.delete') }}</div>
            </div>
          </v-btn>
        </v-col>

        <v-col cols="6" class="pl-1 pr-2">
          <v-btn
            class=""
            color="primary"
            variant="outlined"
            width="100%"
            @click="sendChatReady"
            :loading="btnSendLoading"
            :disabled="disabled"
          >
            <div>
              <div class="text-h6 font-weight-bold message-btn">{{ $t('communication.send') }}</div>
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <template v-slot:actions>
        <v-btn
          color="outline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script lang="ts">
import LocalDataService from '@/service/LocalDataService';
import { chatModule } from '@/store/dataModules/chatModule';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { ChatResponse, GroupChatResponse, MeResponse, NurseryClassResponse } from 'chaild-api/lib';
import VueLoading from '@/components/pages/Loding.vue';
import ClassFilterDialog from '@/components/ClassFilterDialog.vue';
import Vue from 'vue';
import { defineComponent } from "vue";
import { meModule } from '@/store/dataModules/meModule';
import { i18n } from '@/plugins/i18n';

export default defineComponent({
  components: {
    VueLoading,
    ClassFilterDialog,
  },
  data: () => {
    return {
      dialog: false,
      checkbox: [],
      checkboxBulk: [],
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      fetchLoading: false,
      btnSendLoading: false,
      btnRemoveLoading: false,
      selectedClassIds: [] as number[],
    };
  },
  computed: {
    chatReady(): ChatResponse[] {
      this.fetchLoading = true;
      const chatsReady = chatModule.chatsReady;
      if (chatsReady) {
        chatsReady.sort(function(a, b) {
          if (a.date > b.date) {
            return -1;
          } else {
            return 1;
          }
        });
        this.fetchLoading = false;
        return chatsReady;
      }
      this.fetchLoading = false;
      return [];
    },
    bulkChatsReady(): GroupChatResponse[] {
      this.fetchLoading = true;
      const bulkChatsReady = chatModule.bulkChatsReady;
      if (bulkChatsReady) {
        bulkChatsReady.sort(function(a, b) {
          if (a.date > b.date) {
            return -1;
          } else {
            return 1;
          }
        });
        this.fetchLoading = false;
        return bulkChatsReady;
      }
      this.fetchLoading = false;
      return [];
    },
    disabled(): boolean {
      if (this.checkbox.length === 0 && this.checkboxBulk.length === 0) {
        return true;
      } else {
        return false;
      }
    },
    nurseryClasses(): NurseryClassResponse[] {
      return nurseryModule.allClasses ?? [];
    },
  },
  methods: {
    showLongText(body: string) {
      let replace = body.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
      const length = replace.length;
      if (length > 55) {
        replace = replace.slice(0, 55) + '...';
        return replace;
      }
      return body;
    },
    checkReadyMine(createdBy) {
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        if (createdBy.userId === nurserySchool.userId) {
          return true;
        } else {
          return false;
        }
      }
    },
    async routerBack() {
      this.snackbar = false;
      const routes = window.history.length;
      await sessionStorage.setItem('targetTab', 'message');
      this.$router.push('/')
    },
    toChat(chat: ChatResponse) {
      this.$router.push(
        `/communication/chat/${chat.child.childId}?readyChatId=${chat.chatId}&text=${chat.body}&userId=${chat.createdBy?.userId}`
      );
    },
    toChatBulk(chat: GroupChatResponse) {
      this.$router.push(
        `/communication/new-message?readyBulkChatId=${chat.groupChatId}&userId=${chat.createdBy?.userId}`
      );
    },
    formatDate(date: string) {
      const temp = new Date(date);
      const locale = i18n.global.locale.value;
      const messages = i18n.global.messages.value[locale] as any;
      const daysOfWeek = messages.date.daysOfWeek;
      const week = daysOfWeek[temp.getDay()];
      const year = temp.getFullYear();
      const month = temp.getMonth() + 1;
      const day = temp.getDate();
      
      // Format based on locale
      if (locale === 'ja') {
        return `${year}年${month}月${day}日(${week})`;
      } else if (locale === 'en') {
        return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year} (${week})`;
      } else {
        // Vietnamese format: DD/MM/YYYY (Thứ)
        return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year} (${week})`;
      }
    },
    deleteChatReady: async function() {
      try {
        this.btnRemoveLoading = true;
        if (this.checkbox.length > 0) {
          const chatIds = this.checkbox.join(',');
          await chatModule.deleteChatReady(chatIds);
          // await chatModule.removeSendedChatReady(this.checkbox);
          this.init();
          this.snackbar = true;
          this.checkbox = [];
        }
        if (this.checkboxBulk.length > 0) {
          const groupChatId = this.checkboxBulk.join(',');
          await chatModule.deleteAllChatReady(groupChatId);
          // await chatModule.removeSendedBulkChatReady(this.checkboxBulk);
          this.init();
          this.snackbar = true;
          this.checkboxBulk = [];
        }
        this.snackBarText = i18n.global.t('communication.deleted');
      } catch {
      } finally {
        this.btnRemoveLoading = false;
      }
    },
    sendChatReady: async function() {
      try {
        this.btnSendLoading = true;
        let hasChanges = false;
        if (this.checkbox.length > 0) {
          await chatModule.sendChatReady(this.checkbox);
          await chatModule.removeSendedChatReady(this.checkbox);
          this.snackbar = true;
          this.checkbox = [];
          hasChanges = true;
        }
        if (this.checkboxBulk.length > 0) {
          const groupChatIds = this.checkboxBulk;
          await chatModule.sendAllChat({
            groupChatIds,
          });
          await chatModule.removeSendedBulkChatReady(this.checkboxBulk);
          this.snackbar = true;
          this.checkboxBulk = [];
          hasChanges = true;
        }
        if (hasChanges) {
          await this.init();
        }
        this.snackBarText = i18n.global.t('communication.sentSuccess');
      } catch {
      } finally {
        this.btnSendLoading = false;
      }
    },
    async init() {
      this.fetchLoading = true;
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const nurseryId = nurserySchool.nurseryId;
        // classIdsをクエリパラメータとして渡す
        const classIdsParam = this.selectedClassIds.length > 0
          ? this.selectedClassIds.join(',')
          : undefined;
        await Promise.all([
          chatModule.fetchChatReady({ nurseryId, classIds: classIdsParam }),
          chatModule.getAllChatReady({ nurseryId, classIds: classIdsParam }),
          nurseryModule.getAllNurseryClasses(nurseryId),
        ]);
      }
      this.$nextTick(() => {
        this.fetchLoading = false;
      });
    },
    onFilterApply() {
      this.init();
    },
  },
  async mounted() {
    this.init();
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/ress.scss' as *;
@use '@/sass/variables.scss' as *;

.attendance-list-header {
  background-color: #f5f6f6;
  height: 32px !important;
  font-weight: bold !important;
}

.ready-footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  padding-bottom: 10px;
  background: #fff;
}
.padding-box {
  padding-bottom: 80px;
  padding-top: 60px;
}
.header {
  position: fixed;
  z-index: 2 !important;
}
</style>
